<template>
  <label class="checkbox-container">
    <span class="checkbox-text" v-if="label"> {{ label }} </span>
    <span class="checkbox-text" v-if="slotLabel">
      <slot name="label">
        Label
      </slot>
    </span>

    <input type="checkbox" :checked="checked" v-on="listeners" />
    <span class="checkmark" :class="{ 'checkmark--error': error }"></span>
    <div
      class="form-text-validation-checkbox form-text-validation--error"
      v-if="error"
    >
      <span class="text-validation">
        {{ errorMessage }}
      </span>
    </div>
  </label>
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: Boolean,
    label: String,
    errorMessage: {
      type: String,
      default: null,
    },
    error: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    slotLabel() {
      return !!this.$slots.label;
    },
    listeners() {
      return {
        ...this.$listeners,
        change: e => this.$emit('change', e.target.checked),
      };
    },
  },
};
</script>

<style></style>
